export enum StorefrontWidgetButtonSettingPerProduct {
  Both = "both",
  Return = "return",
  PackageProtection = "package_protection",
}
